/**
 * AdminActivity — WCO-3286 general admin audit log view.
 */
import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import AdminActivityTable from './components/AdminActivityTable';

interface AdminActivityProps {
  embedded?: boolean;
}

const AdminActivity: React.FC<AdminActivityProps> = ({ embedded = false }) => {
  const { t } = useLanguage();

  return (
    <div className={embedded ? 'space-y-6' : 'p-6 max-w-[1600px] mx-auto'}>
      {!embedded && (
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
            {t('adminActivity.title')}
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
            {t('adminActivity.description')}
          </p>
        </div>
      )}
      <AdminActivityTable embedded={embedded} />
    </div>
  );
};

export default AdminActivity;
